module.exports = __webpack_public_path__ + "static/media/Style12.984f1938.PNG";